import { useEffect } from "react";

const useFitContextMenuToScreen = (ref: any, deps: any[]) => {
  useEffect(() => {
    // Mock implementation for fitting context menu to screen
  }, deps);
};

export default useFitContextMenuToScreen;
